import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"

export type NavbarBrandProps = {
  transparent: boolean
}

export const NavbarBrand = ({ transparent }: NavbarBrandProps) => {
  const { t } = useTranslation()
  const label = `${t("brand.leninka")} ${t("brand.artIp")}`
  return (
    <Link
      to="/"
      className="flex items-center gap-1.5 sm:gap-2 md:gap-3 shrink-0 min-w-0 group"
      aria-label={label}
    >
      <div className="relative w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center flex-shrink-0" aria-hidden>
        <svg
          viewBox="0 0 36 36"
          className="w-8 h-8 sm:w-9 sm:h-9 transition-opacity duration-300"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="14"
            cy="18"
            r="10"
            className={`transition-colors duration-300 ${transparent ? "fill-white" : "fill-neutral-900"}`}
          />
          <circle
            cx="24.5"
            cy="22"
            r="6.5"
            className={`transition-colors duration-300 ${transparent ? "fill-brand-500" : "fill-[#801818]"}`}
          />
        </svg>
      </div>
      <div className="flex flex-col leading-none">
        <div className="flex items-baseline gap-1">
          <span
            className={`text-sm sm:text-base font-black tracking-tight transition-colors duration-300 ${
              transparent ? "text-white drop-shadow-md" : "text-gray-900"
            }`}
          >
            {t("brand.leninka")}
          </span>
          <span className="text-sm sm:text-base font-black tracking-tight text-brand-500">{t("brand.artIp")}</span>
        </div>
      </div>
    </Link>
  )
}
